import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=e2c47e06"
import script from "./Plugins.vue?vue&type=script&lang=js"
export * from "./Plugins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports